import { dataCouponMinusSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCouponMinusSolid = /*#__PURE__*/createIcon(dataCouponMinusSolid)
export default IconCouponMinusSolid
